var render, staticRenderFns
import script from "./StatsTabs.vue?vue&type=script&lang=js&"
export * from "./StatsTabs.vue?vue&type=script&lang=js&"
import style0 from "./StatsTabs.vue?vue&type=style&index=0&id=7501de4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7501de4c",
  null
  
)

export default component.exports